import { media, DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const TableHeader = styled(Grid)`
  margin: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;

  ${media.lgUp`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const TableFooter = styled('div')`
  margin: ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x2spacePx}px;

  ${media.lgUp`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const HoldingsCount = styled(Grid)`
  background-color: ${({ theme }) => theme.color.phantom};
  width: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x3spacePx}px;
  border-radius: 9999px;
`;

export const HoldingsTableSection = styled('section')`
  margin-bottom: 220px;
`;
